import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import { UserRolesEnum } from 'commons/types/user.roles.enum';
import PrivateRoute from 'commons/utils/privateRoute';
import { AssignSTOReceiveItemPage } from 'pages/sto-receive/assign-sto-item';
import { STOReceiveItemPage } from 'pages/sto-receive/sto-receive-item';
import { STOReceiveListPage } from 'pages/sto-receive/sto-receive-list';
import { STOReceiveSummaryPage } from 'pages/sto-receive/sto-receive-summary';

import { STO_RECEIVE_ROUTE_ROOT, STO_RECEIVE_ROUTES } from './constants';

export const useSTOReceiveRouter = (): React.JSX.Element => (
  <Route
    path={STO_RECEIVE_ROUTE_ROOT}
    element={
      <PrivateRoute
        roles={[
          UserRolesEnum.SUPER_ADMIN,
          UserRolesEnum.ADMIN,
          UserRolesEnum.REPLENISH,
        ]}
      />
    }
  >
    <Route
      path={STO_RECEIVE_ROUTES.ASSIGN}
      element={<AssignSTOReceiveItemPage />}
    />
    <Route path={STO_RECEIVE_ROUTES.LIST} element={<STOReceiveListPage />} />
    <Route path={STO_RECEIVE_ROUTES.ITEM} element={<STOReceiveItemPage />} />
    <Route
      path={STO_RECEIVE_ROUTES.SUMMARY}
      element={<STOReceiveSummaryPage />}
    />
    <Route
      path={STO_RECEIVE_ROUTES.STO_RECEIVE}
      element={<Navigate to={STO_RECEIVE_ROUTES.ASSIGN} />}
    />
  </Route>
);
